import IntervalController from "./interval_controller"

// Este es un intervalo simple. Dura X tiempo y termina.
// Puede tener sonido de metronomo de fondo.
export default class extends IntervalController {

  connect(){
    super.connect();
  }

  playNeededAudio(){
    if (this.isOverDuration()) {
      // sound played in timer player
    } else if (this.currentClick === 0 && this.timerPlayerOutlet.hasAudio("start")) {
      this.timerPlayerOutlet.playAudio("start")
    } else if (this.playClickValue) {
      this.timerPlayerOutlet.playAudio("click")
    }
  }

  renderElapsedTime() {
    super.renderElapsedTime();
    let humanClick = this.currentClick + 1
    let message = `${Math.floor(humanClick / 60)}:${(humanClick % 60).toString().padStart(2, '0')}`
    this.timerPlayerOutlet.clickMessageTarget.innerText = message
  }

}
